import { render, staticRenderFns } from "./wxinfo.vue?vue&type=template&id=3601557f&"
import script from "./wxinfo.vue?vue&type=script&lang=js&"
export * from "./wxinfo.vue?vue&type=script&lang=js&"
import style0 from "./wxinfo.vue?vue&type=style&index=0&id=3601557f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports